import axios from 'axios'
import { getConfig } from './runtimeConfig'

const CTT_DISPATCH_FLAG_KEY = 'enovo-supplier-order-dispatch-FE'
const DEFAULT_ENTITY_ID = 'movimenta-fe-suppliers'
const SUPPLIER_PORTAL_CUTOVER_FLAG_KEY = 'sfp-supplier-portal-cutover'

// Runtime config (settings.json) loads async on bootstrap, so Flipt config is
// only available once requests fire. Resolve each lazily (these run on a
// dispatch action, always after loadRuntimeConfig) rather than at module load.
const fliptUrl = () => (getConfig('VUE_APP_FLIPT_URL') || '').replace(/\/$/, '')
const fliptEnvironment = () => getConfig('VUE_APP_FLIPT_ENVIRONMENT') || 'default'
const fliptNamespace = () => getConfig('VUE_APP_FLIPT_NAMESPACE') || 'default'
const fliptToken = () => getConfig('VUE_APP_FLIPT_TOKEN') || ''

const normalizeContext = (context = {}) => Object.keys(context).reduce((accumulator, key) => {
  const value = context[key]

  if (value === undefined || value === null || value === '') return accumulator

  accumulator[key] = `${value}`
  return accumulator
}, {})

const createHeaders = () => {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }

  const token = fliptToken()
  if (token) headers.Authorization = `Bearer ${token}`

  return headers
}

const isConfigured = () => Boolean(fliptUrl())

const isEnabled = async (flagKey, { entityId = DEFAULT_ENTITY_ID, context = {} } = {}) => {
  if (!flagKey || !isConfigured()) return false

  try {
    const response = await axios.post(`${fliptUrl()}/evaluate/v1/boolean`, {
      environmentKey: fliptEnvironment(),
      namespaceKey: fliptNamespace(),
      flagKey,
      entityId: `${entityId}`,
      context: normalizeContext(context)
    }, {
      headers: createHeaders(),
      timeout: 5000
    })

    return Boolean(response.data && response.data.enabled)
  } catch (error) {
    return false
  }
}

const isCttDispatchEnabled = options => isEnabled(CTT_DISPATCH_FLAG_KEY, options)

// Entity = the login; the segment matches context.username, as the operator screen's flag does.
const isSupplierPortalCutoverEnabled = login => (login
  ? isEnabled(SUPPLIER_PORTAL_CUTOVER_FLAG_KEY, { entityId: login, context: { username: login } })
  : Promise.resolve(false))

export const fliptService = {
  isConfigured,
  isEnabled,
  isCttDispatchEnabled,
  isSupplierPortalCutoverEnabled
}



// WEBPACK FOOTER //
// ./src/services/fliptService.js